import { css } from 'styled-components'
import useWindowDimensions from './hooks/useWindowDimensions'

export const breakpointSizes = {
  sm: '480px',
  md: '1024px',
  lg: '1920px',
}

const breakpoints = Object.keys(breakpointSizes).reduce(
  (accumulator, label) => {
    accumulator[label] = (...args) => css`
      @media (min-width: ${breakpointSizes[label]}) {
        ${css(...args)};
      }
    `
    accumulator[`${label}Max`] = (...args) => css`
      @media (max-width: ${breakpointSizes[label]}) {
        ${css(...args)};
      }
    `
    return accumulator
  },
  {}
)

// Factory for hooks
export const useBreakpoints = Object.keys(breakpointSizes).reduce(
  (accumulator, label) => {
    accumulator[label] = () => {
      const [w] = useWindowDimensions()
      const breakpoint = parseInt(breakpointSizes[label], 10)

      return w >= breakpoint
    }

    accumulator[`${label}Max`] = () => {
      const [w] = useWindowDimensions()
      const breakpoint = parseInt(breakpointSizes[label], 10)

      return w <= breakpoint
    }

    return accumulator
  },
  {}
)

export default breakpoints
